function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import MediaBase from "./MediaBase";
import MediaToolbar from "./MediaToolbar";
import MediaButtonbar from "./MediaButtonbar";
import MediaPreview from "./MediaPreview";
import MediaUpload from "./MediaUpload";
import NavSettings from "../NavSettings/NavSettings";
import NavToolbar from "../NavToolbar/NavToolbar";
import NavTabs from "../NavTabs/NavTabs";
import ButtonSave from "../NavToolbar/ButtonSave";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    display: "flex",
    zIndex: 2,
    alignItems: "center",
    justifyContent: "flex-end",
    height: theme.spacing(7),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: "inherit",
    "& + *": {
      zIndex: 1,
      marginTop: theme.spacing(7)
    },
    "& + [data-layout=imagePreview]": {
      zIndex: 1,
      marginTop: 0
    }
  },
  navTabs: {
    flexGrow: 1,
    marginLeft: theme.spacing(1),
    color: "inherit"
  },
  navSettings: {
    display: "flex",
    margin: theme.spacing(1)
  },
  navToolbar: {
    display: "flex",
    color: "inherit"
  }
}));

const MediaHeader = ({
  menu,
  toolbar,
  settings
}) => {
  const classes = useStyles();
  toolbar = toolbar.map(item => {
    if (item.type === "edit") {
      return false;
    }

    return item;
  });
  return React.createElement("header", {
    className: classes.header
  }, menu && React.createElement(NavTabs, {
    className: classes.navTabs,
    tabs: menu
  }), settings && React.createElement(NavSettings, {
    className: classes.navSettings,
    settings: settings
  }), toolbar && React.createElement(NavToolbar, {
    className: classes.navToolbar,
    toolbar: toolbar
  }));
};

const MediaBody = ({
  children
}) => {
  const classes = useStyles();
  return React.createElement("div", {
    className: classes.body
  });
};

const LayoutMedia = (_ref) => {
  let backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      upload = _ref.upload,
      uploadProgress = _ref.uploadProgress,
      mediaId = _ref.mediaId,
      mediaType = _ref.mediaType,
      media = _ref.media,
      imageUrl = _ref.imageUrl,
      menu = _ref.menu,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["backgroundColor", "color", "upload", "uploadProgress", "mediaId", "mediaType", "media", "imageUrl", "menu", "buttons", "children"]);

  if (mediaType === "image") {
    backgroundColor = "#333";
    color = "white";
  }

  if (mediaType === "video") {
    backgroundColor = "black";
    color = "white";
  }

  if (mediaType === "audio") {
    backgroundColor = "white";
  }

  const baseProps = _extends({}, props, {
    backgroundColor: backgroundColor,
    color: color
  });

  if (uploadProgress && uploadProgress < 100) {
    return React.createElement(MediaBase, baseProps, React.createElement(MediaHeader, props), React.createElement(MediaUpload, _extends({}, props, {
      mediaType: mediaType,
      uploadProgress: uploadProgress
    })));
  }

  if (!mediaId && upload || !mediaId && buttons) {
    return React.createElement(MediaBase, baseProps, React.createElement(MediaUpload, _extends({}, props, {
      mediaType: mediaType,
      buttons: buttons
    })));
  }
  /*
   if (!buttons && upload) {
      buttons = getUploadButtons()
  }
   if (buttons && !mediaId) {
      return (
          <MediaBase {...props}>
              <MediaButtonbar buttons={buttons} />
          </MediaBase>
      )
  }
   */


  if (menu) {
    return React.createElement(MediaBase, baseProps, React.createElement(MediaHeader, _extends({}, props, {
      menu: menu
    })), children);
  }

  return React.createElement(MediaBase, baseProps, React.createElement(MediaHeader, props), React.createElement(MediaPreview, media));
};

export default LayoutMedia;